import React from 'react';
import { Portal } from 'semantic-ui-react';

export default Portal;
